interface SentryLike {
  captureException: (error: unknown, context?: unknown) => void;
}

/**
 * Отправка сбоя в мониторинг.
 *
 * Sentry подключается на странице партнёра как глобальный объект, поэтому
 * тянуть его в бандл виджета незачем: если мониторинга нет, ошибка просто
 * уходит в консоль.
 */
export function reportError(error: unknown, componentStack?: string): void {
  const sentry = (window as unknown as { Sentry?: SentryLike }).Sentry;

  if (sentry) {
    sentry.captureException(error, { extra: { componentStack, source: 'letsshine-widget' } });
    return;
  }

  // eslint-disable-next-line no-console
  console.error('[letsshine] сбой виджета', error, componentStack);
}
